import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: 'f5b17db3-5fc1-4b69-8cfb-f764da419698',
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: 'https://mindly-dev.web.app/main/auth/callback', // Ensure this matches Azure
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
